export default __webpack_public_path__ + "e3d4317b919f1d350ef3af3e3967d738.wasm";